export default __webpack_public_path__ + "static/media/configIcon.bd465c92.svg";